import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from '@/App.vue'
import { initClarityAnalytics } from '@/composables/useClarityAnalytics'
import { registerDirectives } from '@/directives'
import { i18n } from '@/i18n'
import router from '@/router'
import '@/styles/index.css'

initClarityAnalytics()

const app = createApp(App)

registerDirectives(app)
app.use(createPinia())
app.use(i18n)
app.use(router)
app.mount('#app')
